import { render, staticRenderFns } from "./SidbearSettingsGroup.vue?vue&type=template&id=9177b088"
import script from "./SidbearSettingsGroup.vue?vue&type=script&lang=js"
export * from "./SidbearSettingsGroup.vue?vue&type=script&lang=js"
import style0 from "./SidbearSettingsGroup.vue?vue&type=style&index=0&id=9177b088&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports